import { translateFormat } from "./api-errors";
import { translate, type MessageKey } from "./messages";

const INDEX_SUFFIX_KEY = "viewer.extractedFieldIndexSuffix";

type ExtractedMetadataLabelTranslate = (
  key: string,
  options?: { defaultValue?: string; n?: number },
) => string;

/** Locale-aware translator for identified-data display labels (singular + numbered suffix). */
export function createExtractedMetadataDisplayLabelTranslator(
  locale: string | null | undefined,
): ExtractedMetadataLabelTranslate {
  return (key, options) => {
    if (key === INDEX_SUFFIX_KEY && options?.n !== undefined) {
      const formatted = translateFormat(INDEX_SUFFIX_KEY, locale, { n: options.n });
      if (formatted !== INDEX_SUFFIX_KEY) {
        return formatted;
      }
      return options.defaultValue ?? ` ${options.n}`;
    }

    const translated = translate(key as MessageKey, locale);
    if (translated !== key) {
      return translated;
    }
    return options?.defaultValue ?? key;
  };
}
